import { render, staticRenderFns } from "./PushChannelSelect.vue?vue&type=template&id=8ebcc8b4&scoped=true"
import script from "./PushChannelSelect.vue?vue&type=script&lang=js"
export * from "./PushChannelSelect.vue?vue&type=script&lang=js"
import style0 from "./PushChannelSelect.vue?vue&type=style&index=0&id=8ebcc8b4&prod&lang=scss&scoped=true"
import style1 from "./PushChannelSelect.vue?vue&type=style&index=1&id=8ebcc8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebcc8b4",
  null
  
)

export default component.exports